import { getGalleryInfo } from '../gallery/galleryHeight';
import { getCurrentSettings } from '../gallery/gallerySettings';
import { LAYOUTS } from '../../constants/settingsConstants';

const urlWindow = new URL(window.location.href);

export const getInstance = () => {
  const instance = urlWindow.searchParams.get('instance');
  return instance || 'no instance found';
};

export const getCompId = () => {
  return window.Wix.Utils.getOrigCompId() || window.Wix.Utils.getCompId();
};

export const isMobile = () => {
  const deviceType = urlWindow.searchParams.get('deviceType');
  return deviceType === 'mobile';
};

export const createHeaders = (accessToken, userId, isBusinessApp) => {
  return {
    'x-instagram-token': accessToken,
    'x-instagram-user-id': userId,
    'x-is-business-app': isBusinessApp,
  };
};

export const buildError = (code, message) => {
  return {
    code,
    status: code,
    message: {
      code,
      message,
    },
  };
};

export const getWidthElement = (element) => {
  if (element) {
    const style = element.currentStyle || window.getComputedStyle(element),
      width = element.offsetWidth,
      margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight),
      border =
        parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);

    return width + margin + border;
  }
  return 0;
};

export const convertDataToProGalleryItems = (medias, isHashtag) => {
  const isMobileDevice = isMobile();
  if (medias && medias.length) {
    return medias.map((media) => {
      const isPrivateAccount = media.type;
      if (isPrivateAccount) {
        media = fixMedia(media);
      }
      const isVideo = media.media_type === 'VIDEO';
      if (isVideo && isHashtag && !media.thumbnail_url) {
        media.thumbnail_url = media.media_url;
      }
      const mediaData = {
        itemId: media.id,
        mediaUrl:
          isVideo && isMobileDevice ? media.thumbnail_url : media.media_url,
        originalData: media,
        metaData: {
          type: isVideo && !isMobileDevice ? 'video' : 'image',
          title: media.text,
          description: media.text,
          poster: isVideo ? media.thumbnail_url || media.media_url : '',
          link: {
            url: media.permalink,
            target: '_blank',
          },
        },
      };

      return mediaData;
    });
  }

  return [];
};

const fixMedia = (media) => {
  media.media_type =
    media.type.toUpperCase() === 'CAROUSEL'
      ? 'CAROUSEL_ALBUM'
      : media.type.toUpperCase();
  media.comments_count = media.comments.count;
  media.like_count = media.likes.count;
  media.media_url = media.videos
    ? media.videos.standard_resolution.url
    : media.images.standard_resolution.url;
  media.text = media.caption.text ? media.caption.text : '';
  media.permalink = media.link;
  media.thumbnail_url = media.videos
    ? media.images.standard_resolution.url
    : '';

  if (media.carousel_media) {
    media.carousel_media = media.carousel_media.map((caruselMedia) => {
      const isVideo = caruselMedia.type.toUpperCase() === 'VIDEO';

      return {
        media_url: isVideo
          ? caruselMedia.videos.standard_resolution.url
          : caruselMedia.images.standard_resolution.url,
        media_type: caruselMedia.type.toUpperCase(),
        thumbnail_url: isVideo
          ? caruselMedia.images.standard_resolution.url
          : '',
      };
    });
  }

  return media;
};

export const getCountImageNeedToDisplay = (type) => {
  const { galleryLayout } = getGalleryInfo(type);
  switch (galleryLayout) {
    case LAYOUTS.GRID:
      const { numberOfImagesPerRow, numRows } = getCurrentSettings(type);
      return numberOfImagesPerRow * numRows;
    case LAYOUTS.COLLAGE:
      const { loadItemsOnSection, countBlocksDisplay } = getCurrentSettings(
        type,
      );
      return loadItemsOnSection * countBlocksDisplay;
    case LAYOUTS.SLIDER:
      const { countItemsSlider } = getCurrentSettings(type);
      return countItemsSlider;
    default:
      break;
  }
};
